import { categories } from '@/mocks/vigorbuy';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
              Categories
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 tracking-tight">
              Shop by Category
            </h2>
          </div>
          <p className="text-base text-foreground-600 max-w-md">
            14 curated categories for smarter buying — browse organized product collections
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop="true">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-[3/4] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={`${cat.name} category - VigorBuy Spreadsheet`}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                title={`${cat.name} - VigorBuy Spreadsheet`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute top-3 right-3">
                <span className="px-3 py-1 rounded-full bg-background-50/90 text-foreground-900 text-[11px] font-semibold whitespace-nowrap">
                  Shop Now
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-lg font-heading font-semibold text-background-50 tracking-tight">
                  {cat.name}
                </p>
                <p className="text-xs text-background-200 mt-1">
                  View Collection
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Visit Main Store
          </a>
        </div>
      </div>
    </section>
  );
}